/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-09-23 11:03:46
 * @version 1.0.0
 */
import React from 'react';

import { ListPane } from '@src/types';

import { Spin, Empty, Icon } from 'antd';

interface Props {
  data: ListPane<any>;
  children: React.ReactNode;
}

const FeedList: React.SFC<Props> = (props: Props) => {
  const { data, children } = props;

  return (
    <>
      {/*正文加载*/}
      {!data.hasLoaded && data.loading && data.list.length === 0 && (
        <div className="k-tech-loading__wrapper">
          <Spin />
        </div>
      )}

      {/*无内容*/}
      {data.hasLoaded && data.list.length === 0 && (
        <Empty className="k-tech-empty" description="暂无内容" image={<div className="img" />} />
      )}

      {/*正文内容*/}
      {data.list.length > 0 && children}

      {/*上拉加载刷新*/}
      {data.list.length > 0 && data.loading && (
        <div className="k-tech-load--more">
          <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />
        </div>
      )}

      {/*到底了*/}
      {data.list.length > 0 && data.isEnded && <div className="k-tech-load--end">已经到底了</div>}
    </>
  );
};

export default React.memo(FeedList);
